import React, { FC, useCallback, useEffect, useState } from 'react'
import { Box } from 'transfix-ui/core'
import { useDebouncedCallback } from 'use-debounce/lib'
import {
  QuickIssueFiltersCountResponse,
  useQuickIssueFiltersCount,
} from 'apps/marketplace/apiTypes/shipments'
import { TIssueState } from 'constants/issueStatus'
import IssueStateButton from './IssueStateButton'
import { TIssueStateOnClick, TStatus } from './types'

interface IIssueStateButtonProps {
  onClick: TIssueStateOnClick
  status: TStatus
  data: QuickIssueFiltersCountResponse | null
  selectedIssueState: TIssueState
}
const IssueStateButtons: FC<IIssueStateButtonProps> = ({
  data,
  onClick,
  selectedIssueState,
  status,
}) => {
  const { quickIssueFiltersCount } = data || {}
  const [quickFilterCount = {}] = quickIssueFiltersCount || []
  const { awaitingResponse = 0, inProgress = 0, pending = 0 } = quickFilterCount
  const allCount = pending + inProgress + awaitingResponse

  return (
    <Box overflow='hidden'>
      <IssueStateButton
        selected={selectedIssueState === 'all'}
        onClick={onClick}
        status={status}
        count={allCount}
        issueState='all'
      />
      <br />
      <IssueStateButton
        selected={selectedIssueState === 'pending'}
        onClick={onClick}
        status={status}
        count={pending}
        issueState='pending'
      />
      <br />
      <IssueStateButton
        selected={selectedIssueState === 'in_progress'}
        onClick={onClick}
        status={status}
        count={inProgress}
        issueState='in_progress'
      />
      <br />
      <IssueStateButton
        selected={selectedIssueState === 'awaiting_response'}
        onClick={onClick}
        status={status}
        count={awaitingResponse}
        issueState='awaiting_response'
      />
    </Box>
  )
}

interface IIssueStateSidebar {
  onClick: TIssueStateOnClick
  status: TStatus
  issueState: TIssueState
  filters: object
}

const IssueStateSidebar = ({ filters, issueState, onClick, status }: IIssueStateSidebar) => {
  const { mutate: quickIssueFiltersCount } = useQuickIssueFiltersCount({})
  const [data, setData] = useState<QuickIssueFiltersCountResponse | null>(null)

  const callApi = useCallback(
    async ({ filters, status }) => {
      const response = await quickIssueFiltersCount({
        filters: {
          ...filters,
          status,
        },
      })
      setData(response)
    },
    [quickIssueFiltersCount]
  )
  // Debounce to prevent API calls on every keystroke
  const [debounceCallApi] = useDebouncedCallback(callApi, 250)
  const stringifiedDependencies = JSON.stringify({ filters, status })
  useEffect(() => {
    const parsedDependencies = JSON.parse(stringifiedDependencies)
    const { filters, status } = parsedDependencies
    debounceCallApi({
      filters,
      status,
    })
  }, [debounceCallApi, stringifiedDependencies])

  return (
    <div>
      <strong>Issues</strong>
      <IssueStateButtons
        onClick={onClick}
        status={status}
        data={data}
        selectedIssueState={issueState}
      />
    </div>
  )
}

export default IssueStateSidebar
